// extracted by mini-css-extract-plugin
export default {"flipCard":"HajjCard_flipCard__LS1a1","flipCardInner":"HajjCard_flipCardInner__F+nf-","flipCardFront":"HajjCard_flipCardFront__NtjhD","flipCardBack":"HajjCard_flipCardBack__DERKr"};